import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#040404" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Ignite Your Business Through Digital Transformation with
              Proficient React Native App Development Team in Dubai
            </h2>
            <p>
              TekRevol, one of the leading cross-platform app development
              companies, offer innovative solutions customized to your
              requirements. Our expert React Native Mobile App developers in the
              Dubai region are proficient at every feature of business
              improvement. What makes us different is our unyielding quest for
              quality and affordability, guaranteeing competitive rates while
              providing uncompromising excellence.
            </p>
            <p>
              Team up with one of the best React Native app development
              companies in the Dubai to transform your business digitally.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#040404",
                border: "1px solid #040404",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Schedule Free Consultation!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <StaticImage
              src="../../images/location_new/fold5/react_native_dubai.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={866}
              height={1042}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
